import { Reveal, SectionHeading } from "./Reveal";
import { Navigation, MapPin, Car, Phone } from "lucide-react";

export const LocationSection = ({ hotel }) => (
  <section id="location" className="bg-[#EFEBE1] py-20 md:py-28" data-testid="location-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <SectionHeading eyebrow="Find Us" title="Right on US-431, Easy to Reach" testId="location" />
          <Reveal delay={0.1}>
            <p className="text-[#4A5568] mt-6 leading-relaxed text-sm sm:text-base max-w-md">
              {hotel?.location_note}
            </p>
            <div className="mt-8 space-y-4">
              <p className="flex items-start gap-3 text-[#0D1B2A]" data-testid="location-address">
                <MapPin size={18} className="text-[#C5A059] shrink-0 mt-0.5" />
                <span className="text-sm sm:text-base font-medium">{hotel?.address}</span>
              </p>
              <p className="flex items-start gap-3 text-[#4A5568]" data-testid="location-landmark">
                <Car size={18} className="text-[#C5A059] shrink-0 mt-0.5" />
                <span className="text-sm">On US-431, next to McDonald's · Free on-site parking</span>
              </p>
              <a href={hotel?.phone_href || "tel:+13346870000"} className="flex items-start gap-3 text-[#0D1B2A] hover:text-[#C5A059] transition-colors" data-testid="location-phone">
                <Phone size={18} className="text-[#C5A059] shrink-0 mt-0.5" />
                <span className="text-sm font-medium">{hotel?.phone}</span>
              </a>
            </div>
            <a
              href={hotel?.maps_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 mt-9 bg-[#0A192F] text-[#F8F6F0] hover:bg-[#C5A059] hover:text-[#0A192F] px-8 py-4 rounded-full font-semibold transition-all duration-300 shadow-lg"
              data-testid="get-directions-button"
            >
              <Navigation size={17} /> Get Directions on Google Maps
            </a>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="rounded-3xl overflow-hidden border border-[#C5A059]/30 shadow-2xl" data-testid="location-map-frame">
            <iframe
              title="Lake Eufaula Inn on Google Maps"
              src={hotel?.map_embed}
              className="w-full h-[380px] sm:h-[440px] border-0"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="google-map-embed"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
